import bookingMatchNames from '../../main/bookingMatchNames'

function getFilteredBookings(billableBookings, excludeTempImmunes, filterVals) {
  const {
    showRejected,
    showNonRejected,
    rateToFilter,
    trackingToFilter,
    filteredConversionReason,
    omnisearchVal,
    priorStayCount,
    showAnomaly,
    rateCategoryToFilter
  } = filterVals

  return billableBookings
    .filter(booking => {
      if (showRejected && booking.isInvoicingRejected === showRejected) {
        return booking
      }

      if (showNonRejected && !booking.isInvoicingRejected === showNonRejected) {
        return booking
      }

      if (excludeTempImmunes && booking.hasTempFilterImmunity) {
        return booking
      }

      return false
    })
    .filter(booking => {
      if (rateToFilter === 'any') {
        return booking
      }

      if (booking.convertedRateCode === rateToFilter) {
        return booking
      }

      return false
    })
    .filter(booking => {
      if (trackingToFilter === 'any') {
        return booking
      }

      if (booking.convertedTrackingCode === trackingToFilter) {
        return booking
      }

      return false
    })
    .filter(booking => {
      if (rateCategoryToFilter === 'any') {
        return true
      }

      if (booking.convertedRateCodeKind === rateCategoryToFilter) {
        return true
      }

      return false
    })
    .filter(booking => {
      if (filteredConversionReason === 'Any conversion reason') {
        return booking
      }

      if (bookingMatchNames[booking.conversionIsBasedOn] === filteredConversionReason) {
        return booking
      }

      return false
    })
    .filter(booking => {
      if (omnisearchVal === '' || omnisearchVal.length < 3) {
        return booking
      }

      if (`${booking.inviteBookingConversionDetailId}` === omnisearchVal) {
        return booking
      }

      if (booking.searchKey.includes(omnisearchVal.toLowerCase())) {
        return booking
      }

      return false
    })
    .filter(({ numberOfPriorsByName }) => {
      if (priorStayCount === 'Any prior stays') {
        return true
      }

      if (priorStayCount === '0-3' && numberOfPriorsByName < 4) {
        return true
      }

      if (priorStayCount === '0-5' && numberOfPriorsByName < 6) {
        return true
      }

      if (priorStayCount === '4+' && numberOfPriorsByName > 4) {
        return true
      }

      if (priorStayCount === '6+' && numberOfPriorsByName > 6) {
        return true
      }

      return false
    })

    .filter(booking => {
      if (showAnomaly) {
        if (booking.priorStayCount > 9) {
          return true
        }

        if (booking.daysFromInviteUntilBooking > 29) {
          return true
        }

        if (booking.conversionIsBasedOn === bookingMatchNames.LastNameZip) {
          return true
        }

        if (booking.conversionIsBasedOn === bookingMatchNames.LastNameZip) {
          return true
        }

        if (booking.conversionIsBasedOn === bookingMatchNames.PartialBookingGuestName) {
          return true
        }

        return false
      } else {
        return true
      }
    })
}

export default getFilteredBookings
